import { http } from "Utils/http";
import { Form, Tabs, Tab, Row, Col, Card,Dropdown,Button, Stack,Modal,CloseButton, Badge } from "react-bootstrap";
import { useState, useEffect} from "react";
import { useLocation } from 'react-router-dom';
import { store} from 'Store';
import { setGlobalErrorStatus, setGlobalSuccessStatus} from 'Components/StatusHandling'
import { useDispatch } from "react-redux"
import { GetTableauReportTextInputData, GetTableauReportNumberInputData, GetTableauReportCheckboxInputData, GetTableauReportSelectInputData, GetTableauReportRadioInputData } from 'Containers/Private/Tableau/TableauReportFields';
import { FormInputDisplay} from 'Components/Forms/FormInputDisplay.js';
import { useNavigate} from 'react-router-dom';
import { ERROR_MESSAGES } from "Utils/constants";
import { TextButton } from "Components/Button";

const CreateTableauReportDef = () => {
    const navigate = useNavigate();

    let location = useLocation();
    var passedData = location.state;
    //console.log("PASSED DATA");
    //console.log(passedData);
    const [backRedirect, setBackRedirect] = useState(passedData.backRedirect);
    //const [isLoading, setIsLoading] = useState(true)

    var dispatch = useDispatch();

    //const loginState = store.getState().loginInfo;

   const ACTIONS = {
        CALL_API: 'call-api',
        SUCCESS: 'success',
        ERROR: 'error',
        SET_INITIAL_DATA: 'set-data',

        TEXT_CHANGE: 'text-change',
        TEXT_SET_ERRORS: 'text-set-errors',
        TEXT_REMOVE_ERRORS: 'text-remove-errors',
        TEXT_AREA_CHANGE: 'text-area-change',

        RADIO_CHANGE: 'radio-change',
        RADIO_SET_ERRORS: 'radio-set-errors',
        RADIO_REMOVE_ERRORS: 'radio-remove-errors',

        SELECT_CHANGE: 'select-change',
        SELECT_SET_ERRORS: 'select-set-errors',
        SELECT_REMOVE_ERRORS: 'select-remove-errors',
        SELECT_UPDATE_CHOICES: 'select-update-choices',

        SET_INITIAL_CHECK_DATA: 'set-check-data',
        CHECK_UPDATE_CHOICES: 'check-update-choices',
        CHECK_CHANGE: 'check-change',
        CHECK_TOGGLE_DISABLE: 'check-toggle-disable',
        CHECK_SET_ERRORS: 'check-set-errors',
        CHECK_REMOVE_ERRORS: 'check-remove-errors',

        DATE_CHANGE: 'date-change',
        DATE_SET_ERRORS: 'date-set-errors',
        DATE_REMOVE_ERRORS: 'date-remove-errors',

        PHONE_CHANGE: 'phone-change',
        PHONE_SET_ERRORS: 'phone-set-errors',
        PHONE_REMOVE_ERRORS: 'phone-remove-errors',

        FILE_CHANGE: 'file-change',
        FILE_SET_ERRORS: 'file-set-errors',
    };

    const [isLoading, setIsLoading] = useState(true);

    const hForm = { is: true, labelCols: { lg: 3, md: 4 }, inputCols: { lg: 6 } };
    //const vForm = { is: false, labelCols: { lg: 3, md: 4 }, inputCols: { lg: 7 } };
    //const tForm = { is: false, labelCols: { lg: "auto", md: "auto"}, inputCols: { lg: "2" } };

    var [tableauReportWorkbook, tableauReportWorkbookInputDispatch] = GetTableauReportSelectInputData('tableauReportWorkbook', null);
    var [tableauReportWorkbookView, tableauReportWorkbookViewInputDispatch] = GetTableauReportSelectInputData('tableauReportWorkbookView', null); 
    var [tableauReportName, tableauReportNameInputDispatch] = GetTableauReportTextInputData('tableauReportName', ''); 
    var [tableauReportCategory, tableauReportCategoryInputDispatch] = GetTableauReportSelectInputData('tableauReportCategory', null); 
    var [tableauReportCFSetting, tableauReportCFSettingInputDispatch] = GetTableauReportSelectInputData('tableauReportCFSetting', null); 
    var [tableauReportCFVersion, tableauReportCFVersionInputDispatch] = GetTableauReportSelectInputData('tableauReportCFVersion', null); 
    var [tableauReportDispOrder, tableauReportDispOrderInputDispatch] = GetTableauReportNumberInputData('tableauReportDispOrder','1.0'); 
    var [tableauReportStatus, tableauReportStatusInputDispatch] = GetTableauReportRadioInputData('tableauReportStatus', 1, false); 
    var [tableauReportOrgAccess, tableauReportOrgAccessInputDispatch] = GetTableauReportCheckboxInputData('tableauReportOrgAccess', null); 

    //var [cfSettingId, setCfSettingId] = useState(null);
    //var [cfVersions, setCfVersions] = useState([]);
    
    useEffect(() => {
        loadFormData();
    }, []);

    const getFormData = async () => {

        var url = '/api/manageTableau/addTableauReportDefinition';
        const loginState = store.getState().loginInfo;

        return http.post(url, null, {
            headers: {
                "Authorization": "Bearer " + loginState.token
             }
        });
    }

    const loadFormData = () => {
        setIsLoading(true);
        getFormData().then((res) => {
            //console.log("getFormData ", res);
            if (res.status != 1) {
                setGlobalErrorStatus({
                    dispatch: dispatch,
                    popupData: {
                        visible: true,
                        title: ERROR_MESSAGES.DATA_ERROR.title,
                        msg: res.globalErrorMessageList[0],
                        showContactHelp: true
                    },
                    redirect: {
                        redirect: false,
                        redirectFirst: false,
                        path: "",
                        data: {}
                    }
                });
            }
            else {
                var d = res.data;

                //console.log(d);
                if (d.workbookList != null) {
                    var o = [];
                    o.push({
                        index: null,
                        value: -1,
                        title: null,
                        displayValue: "Select Workbook",
                        name: null,
                        isSelected: true
                    })
                    d.workbookList.map((option, index) => {
                        //console.log(option);
                        var owner = {
                            index: index,
                            id: option.entryValue,
                            value: option.entryValue,
                            title: null,
                            displayValue: option.entryDisplay,
                            isSelected: false,
                            name: option.entryValue,
                            disabled: false
                        }
                        o.push(owner);
                        //console.log(owner);
                        return owner;
                    });

                    tableauReportWorkbookInputDispatch({
                        type: ACTIONS.SELECT_UPDATE_CHOICES,
                        options: o
                    })
                }

                if (d.rptCategoryList != null) {
                    var o = [];
                    o.push({
                        index: null,
                        value: -1,
                        title: null,
                        displayValue: "Select Report Category",
                        name: null,
                        isSelected: true
                    })
                    d.rptCategoryList.map((option, index) => {
                        //console.log(option);
                        var owner = {
                            index: index,
                            id: option.id,
                            value: option.id,
                            title: null,
                            displayValue: option.categoryName,
                            isSelected: false,
                            name: option.categoryName,
                            disabled: false
                        }
                        o.push(owner);
                        //console.log(owner);
                        return owner;
                    });

                    tableauReportCategoryInputDispatch({
                        type: ACTIONS.SELECT_UPDATE_CHOICES,
                        options: o
                    })
                }


                if (d.cfSettingList != null) {
                    var o = [];
                    o.push({
                        index: null,
                        value: -1,
                        title: null,
                        displayValue: "Select Common Formats Setting",
                        name: null,
                        isSelected: true
                    })
                    d.cfSettingList.map((option, index) => {
                        //console.log(option);
                        var owner = {
                            index: index,
                            id: option.id,
                            value: option.id,
                            title: null,
                            displayValue: option.name,
                            isSelected: false,
                            name: option.name,
                            disabled: false
                        }
                        o.push(owner);
                        //console.log(owner);
                        return owner;
                    });

                    tableauReportCFSettingInputDispatch({
                        type: ACTIONS.SELECT_UPDATE_CHOICES,
                        options: o
                    })
                    
                }
                
                if (d.lstCfversions != null) {
                    var o = [];
                    o.push({
                        index: null,
                        value: -1,
                        title: null,
                        displayValue: "Select Common Formats Version",
                        name: null,
                        isSelected: true
                    })
                    d.lstCfversions.map((option, index) => {
                        //console.log(option);
                        var owner = {
                            index: index,
                            id: option.cfSettingId,
                            value: option.id,
                            title: null,
                            displayValue: option.timePrdCd,
                            isSelected: false,
                            name: option.timePrdCdDesc,
                            disabled: false
                        }
                        o.push(owner);
                        //console.log(owner);
                        return owner;
                    });

                    tableauReportCFVersionInputDispatch({
                        type: ACTIONS.SELECT_UPDATE_CHOICES,
                        options: o
                    })
                    
                }
            }
            setIsLoading(false);
            return d;
        }).catch((error) => {
            //console.log("Error caught while loading data: " + error);

            setGlobalErrorStatus({
                dispatch: dispatch,
                popupData: {
                    visible: true,
                    title: ERROR_MESSAGES.DATA_ERROR.title,
                    msg: ERROR_MESSAGES.DATA_ERROR.message,
                    showContactHelp: true
                },
                redirect: {
                    redirect: false,
                    redirectFirst: false,
                    path: "",
                    data: {}
                },
                error: error
            });
        });
        
    };

    const getWorkbookViewData = async (id) => {

        var url = '/api/manageTableau/getTableauWorkBookViewByWorkBookId';
        const loginState = store.getState().loginInfo;
        var data = {
            workbookId: id
        }

        return http.post(url, data, {
            headers: {
                "Authorization": "Bearer " + loginState.token
            }
        });
    }

    const loadWorkbookViewData = (id) => {
         getWorkbookViewData(id).then((res) => {
            //console.log("getWorkbookViewData ", res);
            if (res.status != 1) {
                setGlobalErrorStatus({
                    dispatch: dispatch,
                    popupData: {
                        visible: true,
                        title: ERROR_MESSAGES.DATA_ERROR.title,
                        msg: res.globalErrorMessageList[0],
                        showContactHelp: true
                    },
                    redirect: {
                        redirect: false,
                        redirectFirst: false,
                        path: "",
                        data: {}
                    }
                });
            }
            else {
                var d = res.data;

                //console.log(d);
                if (d != null) {
                    var o = [];
                    o.push({
                        index: null,
                        value: -1,
                        title: null,
                        displayValue: "Select Workbook View",
                        name: null,
                        isSelected: true
                    })
                    d.map((option, index) => {
                        //console.log(option);
                        var owner = {
                            index: index,
                            id: option.id,
                            value: option.contentUrl + "," + option.name,
                            title: null,
                            displayValue: option.viewUrlName,
                            isSelected: false,
                            name: option.name,
                            disabled: false
                        }
                        o.push(owner);
                        //console.log(owner);
                        return owner;
                    });

                    tableauReportWorkbookViewInputDispatch({
                        type: ACTIONS.SELECT_UPDATE_CHOICES,
                        options: o
                    })

                    if(o.length>1){
                        tableauReportWorkbookViewInputDispatch({
                            type: ACTIONS.SELECT_CHANGE,
                            disabled: false
                        })
                    }
                    
                }
                
            }
            //setIsLoading(false);
            return d;
        }).catch((error) => {
            //console.log("Error caught while loading data: " + error);

            setGlobalErrorStatus({
                dispatch: dispatch,
                popupData: {
                    visible: true,
                    title: ERROR_MESSAGES.DATA_ERROR.title,
                    msg: ERROR_MESSAGES.DATA_ERROR.message,
                    showContactHelp: true
                },
                redirect: {
                    redirect: false,
                    redirectFirst: false,
                    path: "",
                    data: {}
                },
                error: error
            });
        });
        
    };
    
    const getSelectedWorkbook = () => {
        var l = tableauReportWorkbook.options;

        //console.log(l);
        for(var x = 0 ; x<l.length ; x++){
            if(l[x].isSelected==true){
                return l[x].value;
            }
        }
        return null;
    }

    useEffect(()=> {
        
        if(tableauReportWorkbook!=null && getSelectedWorkbook()!=null){
            var selected = getSelectedWorkbook();
            if(selected!=-1){
                loadWorkbookViewData(selected);
            }
            else{
                tableauReportWorkbookViewInputDispatch({
                    type: ACTIONS.SELECT_UPDATE_CHOICES,
                    options: [
                        {
                            index: null,
                            value: -1,
                            title: null,
                            displayValue: "Select Workbook View",
                            name: null,
                            isSelected: true
                        }
                    ]
                })

                tableauReportWorkbookViewInputDispatch({
                    type: ACTIONS.SELECT_CHANGE,
                    disabled: true
                })
            } 
        }
    },[tableauReportWorkbook])

    const getSelected = (s, noNeg) => {

        //console.log(s);
        for(var x = 0 ; x<s.length ; x++){
            if(s[x].isSelected==true){
                if(noNeg==true && s[x].value==-1){
                    return null;
                }
                else{
                    return s[x].value;
                }
                
            }
        }
        return null;
    }

    const getSelectedDisplayValue = (s) => {

        //console.log(s);
        for(var x = 0 ; x<s.length ; x++){
            if(s[x].isSelected==true){
                return s[x].displayValue;
            }
        }
        return null;
    }

    const getChecked = (s) => {
        var data = [];
        //console.log(s);
        for(var x = 0 ; x<s.length ; x++){
            if(s[x].isChecked==true){
                data.push(s[x].value);
            }
        }
        return data;
    }

    useEffect(()=> {
        if(tableauReportCFSetting!=null && getSelected(tableauReportCFSetting.options)!=null){
            var d = getSelected(tableauReportCFSetting.options);
            if(d!=null && d!=-1){
                tableauReportCFVersionInputDispatch({
                    type: ACTIONS.SELECT_CHANGE,
                    value: -1
                })
            }
        }

    },[tableauReportCFSetting])

    useEffect(()=> {
        if(tableauReportCFVersion!=null && getSelected(tableauReportCFVersion.options)!=null){
            var d = getSelected(tableauReportCFVersion.options);
            if(d!=null && d!=-1){
                tableauReportCFSettingInputDispatch({
                    type: ACTIONS.SELECT_CHANGE,
                    value: -1
                })
            }
        }

    },[tableauReportCFVersion])

    const handleCancel = async () => {
        if (backRedirect.path == null) {
            setBackRedirect("/manage/tableau");
        }
        navigate(
            backRedirect.path != null ? backRedirect.path : "/manage/tableau",
            { state: backRedirect.state }
        );
    };

    const fieldDataAccess = {
        workbookId: {
            value: tableauReportWorkbook,
            dispatch: tableauReportWorkbookInputDispatch
        },
        workbookView: {
            value: tableauReportWorkbookView,
            dispatch: tableauReportWorkbookViewInputDispatch
        },
        reportName: {
            value: tableauReportName,
            dispatch: tableauReportNameInputDispatch
        },
        cfSetting: {
            value: tableauReportCFSetting,
            dispatch: tableauReportCFSettingInputDispatch
        },
        rptCategory: {
            value: tableauReportCategory,
            dispatch: tableauReportCategoryInputDispatch
        },
        displayOrder: {
            value: tableauReportDispOrder,
            dispatch: tableauReportDispOrderInputDispatch
        },
        timePrdId: {
            value: tableauReportCFVersion,
            dispatch: tableauReportCFVersionInputDispatch
        },
        status: {
            value: tableauReportStatus,
            dispatch: tableauReportStatusInputDispatch
        },
        pso: {
            value: tableauReportOrgAccess,
            dispatch: tableauReportOrgAccessInputDispatch
        },
        ahrq: {
            value: tableauReportOrgAccess,
            dispatch: tableauReportOrgAccessInputDispatch
        },
        psoppc: {
            value: tableauReportOrgAccess,
            dispatch: tableauReportOrgAccessInputDispatch
        }
    }

    function addErrorMessages (object, fieldErrors, dispatch, isFirst) {
        //console.log("ADD ERROR MESSAGES", object, fieldErrors);

        if (fieldErrors != null) {

            var err = fieldErrors.errorMessages;


            if (isFirst == true) {
                (object.InputRef).current.focus();
                //console.log("ISFIRST");
            }

            var type = object.type;

            switch (type) {
                case "text":
                    dispatch({
                        type: ACTIONS.TEXT_SET_ERRORS,
                        errors: err
                    })
                    break;
                case "number":
                    dispatch({
                        type: ACTIONS.TEXT_SET_ERRORS,
                        errors: err
                    })
                    break;
                 case "select":
                    dispatch({
                        type: ACTIONS.SELECT_SET_ERRORS,
                         errors: err
                    })
                    break;
                case "radio":
                    dispatch({
                        type: ACTIONS.RADIO_SET_ERRORS,
                        //name: fieldName,
                        errors: err
                    })
                    break;
                case "checkbox":
                    dispatch({
                        type: ACTIONS.CHECK_SET_ERRORS,
                         errors: err
                    })
                    break;
            }

        }
    }

    const handleSubmit = async () => {
        
        var url = '/api/manageTableau/saveTableauReportDefinition';
        var values = {
            
            workbookId: getSelectedDisplayValue(tableauReportWorkbook.options,true),
            workbookView: getSelected(tableauReportWorkbookView.options,true),
            reportName: tableauReportName.value,
            cfSetting: getSelected(tableauReportCFSetting.options,true),
            rptCategory: getSelected(tableauReportCategory.options,true),
            displayOrder: tableauReportDispOrder.value,
            timePrdId: getSelected(tableauReportCFVersion.options,true),
            status: tableauReportStatus.getValue(tableauReportStatus.radioButtons),
            pso: getChecked(tableauReportOrgAccess.checkBoxes).includes("pso"),
            ahrq: getChecked(tableauReportOrgAccess.checkBoxes).includes("ahrq"),
            psoppc: getChecked(tableauReportOrgAccess.checkBoxes).includes("psoppc")
        };
 
        const loginState = store.getState().loginInfo;
        const res = http.post(url, values, {
            timeout: 80000,
            headers: {
                "Authorization": "Bearer " + loginState.token
            }
        }).then((response) => {
            //console.log("print out /users/adduser", response);
            if (response != null) {
                //console.log(response);
                var statusCode = response.status;
                if (statusCode != 1) {
                    if (response.globalErrorMessageList && response.globalErrorMessageList.length > 0) {
                        setGlobalErrorStatus({
                            dispatch: dispatch,
                            popupData: {
                                visible: true,
                                title: ERROR_MESSAGES.GENERAL_ERROR.title,
                                msg: response.globalErrorMessageList,
                                showContactHelp: false
                            },
                            redirect: {
                                redirect: false,
                                redirectFirst: false,
                                path: "",
                                data: {}
                            }
                        });
                    }

                    var d = response.fieldErrors;
                    //console.log("field errors", d);

                    var x = 0;
                    var isFirst = false;

                    for (const [key, value] of Object.entries(fieldDataAccess)) {
                        //console.log("Key: ", key);
                        //console.log("Value: ", value);

                       
                        var values = d[key];

                        //console.log("VALUES", values);

                        if (values != null) {
                            var disp = value.dispatch;
                            var obj = value.value;

                            if (x == 0) {
                                isFirst = true;
                            }
                            else {
                                isFirst = false;
                            }
                            addErrorMessages(obj, values, disp, isFirst);
                            x = x + 1;
                        }
                    }
                }
                else {
                    setGlobalSuccessStatus({
                        dispatch: dispatch,
                        popupData: {
                            visible: true,
                            title: "Success!",
                            msg: response.message!=null ? response.message : "The Interactive Report have been added successfully.",
                            showContactHelp: false
                        },
                        redirect: {
                            redirect: true,
                            redirectFirst: true,
                            path: backRedirect.path,
                            data: backRedirect.state 
                        }
                    });
                }
            }
            else {
                setGlobalErrorStatus({
                    dispatch: dispatch,
                    popupData: {
                        visible: true,
                        title: ERROR_MESSAGES.GENERAL_ERROR.title,
                        msg: ERROR_MESSAGES.GENERAL_ERROR.message,
                        showContactHelp: true
                    },
                    redirect: {
                        redirect: false,
                        redirectFirst: false,
                        path: "",
                        data: {}
                    }
                });
               
            }
        }).catch(function (error) {
            //console.log("submitUser", error);
            setGlobalErrorStatus({
                dispatch: dispatch,
                popupData: {
                    visible: true,
                    title: ERROR_MESSAGES.GENERAL_ERROR.title,
                    msg: ERROR_MESSAGES.GENERAL_ERROR.message,
                    showContactHelp: true
                },
                redirect: {
                    redirect: false,
                    redirectFirst: false,
                    path: "",
                    data: {}
                },
                error: error
            });
        });
        //console.log("submitUser", res);
        return res;
    };

    return (
        isLoading==false 
        ?
            <Row>
                <Row >
                    <Col xl={11} lg={11} md={12} sm={12}>
                        
                        <Card className="p-4" >
                            <Card.Body className="text-start">
                                <Row>
                                    <h1 id="mainContent" className="header1 text-start mb-3 blue bold" >Add Interactive Report Definition</h1>
                                </Row>
                                <Row>
                                    <Form>
                                       
                                        <FormInputDisplay fieldData={tableauReportWorkbook} inputDispatch={tableauReportWorkbookInputDispatch} isHorizontal={false} hideLabel={false} horizontalForm={hForm}></FormInputDisplay>  
                                        <FormInputDisplay fieldData={tableauReportWorkbookView} inputDispatch={tableauReportWorkbookViewInputDispatch} isHorizontal={false} hideLabel={false} horizontalForm={hForm}></FormInputDisplay>
                                        <FormInputDisplay fieldData={tableauReportName} inputDispatch={tableauReportNameInputDispatch} isHorizontal={false} hideLabel={false} horizontalForm={hForm}></FormInputDisplay>                             
                                        <FormInputDisplay fieldData={tableauReportCategory} inputDispatch={tableauReportCategoryInputDispatch} isHorizontal={false} hideLabel={false} horizontalForm={hForm}></FormInputDisplay>  

                                        <FormInputDisplay fieldData={tableauReportCFSetting} inputDispatch={tableauReportCFSettingInputDispatch} isHorizontal={false} hideLabel={false} horizontalForm={hForm} rowClasses="mb-0"></FormInputDisplay>
                                        <Row className="mb-3">
                                            <Col className="col-lg-3 col-md-4">
                                                    <p></p>
                                            </Col>
                                            <Col className="col-lg-6">
                                                    <p className="form-label mb-0">or</p>
                                            </Col>
                                        </Row>
                                        <FormInputDisplay fieldData={tableauReportCFVersion} inputDispatch={tableauReportCFVersionInputDispatch} isHorizontal={false} hideLabel={false} horizontalForm={hForm}></FormInputDisplay>
                                        
                                        <FormInputDisplay fieldData={tableauReportDispOrder} inputDispatch={tableauReportDispOrderInputDispatch} isHorizontal={false} hideLabel={false} horizontalForm={hForm}></FormInputDisplay>  
                                        <FormInputDisplay fieldData={tableauReportStatus} inputDispatch={tableauReportStatusInputDispatch} isHorizontal={false} hideLabel={false} horizontalForm={hForm}></FormInputDisplay>
                                        <FormInputDisplay fieldData={tableauReportOrgAccess} inputDispatch={tableauReportOrgAccessInputDispatch} isHorizontal={false} hideLabel={false} horizontalForm={hForm}></FormInputDisplay>

                                        <Stack className="pt-3" direction="horizontal" gap={3}>
                                            {/* Submit Button */}
                                            <TextButton
                                                variant="normal"
                                                onClick={handleSubmit}
                                                content={"Submit"}
                                            >
                                            </TextButton>

                                            {/* Cancel Button */}
                                            <TextButton
                                                variant="outline"
                                                onClick={handleCancel}
                                                content={"Cancel"}
                                            >
                                            </TextButton>
                                        </Stack>
                                    
                                    </Form>
                                </Row>
                                    
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Row>
        : null    
    )
}

export default CreateTableauReportDef;